import PubSub from "pubsub-js";
import { isEmpty } from "underscore";
import { MetricConstants } from "../../components/Constants";
import { pubsubEvents } from "../../components/helpers/socket/pubsubEvent";
import config from "../../components/helpers/socket/config";
import { endMetric } from "../metric-utils/metricUtils";
/**
 * This is the main handler for received socket
 * messages that can be shared across your
 * widget content sandbox.
 *
 * The switch statement is intended to
 * match received actions to a PubSub.publish event.
 */

export function cmed_market_data_messageReceived(data) {
  if (data.status && (data.status === "ERROR" || data.status === "FAILURE")) {
    if (isEmpty(data.warnings)) {
      PubSub.publish(pubsubEvents.eventKeys.DISPOSE_ANY_CARD_OVERLAYS, data);
      PubSub.publish(pubsubEvents.socketKeys.HANDLE_SOCKET_ERROR, data);
    }
    if (
      data.errors[0] !== pubsubEvents.errorMessage.REQUEST_ERROR_CMED_TIMEOUT &&
      data.errors[0] !==
        pubsubEvents.errorMessage.CMED_TOKEN_UNKNOWN_SQUARE_BRACKETS &&
      data.errors[0] !== pubsubEvents.errorMessage.CMED_TOKEN_UNKNOWN &&
      data.errors[0] !== pubsubEvents.errorMessage.ERROR_MESSAGE_GENERIC
    ) {
      switch (data.action) {
        case config.socket.actions.CMED_PRODUCTS:
          console.log(`❌ ${data.type}`);
          PubSub.publish(
            pubsubEvents.socketKeys.CMED_ALL_PRODUCTS_FAILURE,
            data,
          );
          // Commenting this approach out for now - initiated a backup call and handled it in the component via pubsub : TradingInstrumentsForUser
          // PubSub.publish(pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST, data)
          break;
        case config.socket.actions.CMED_STRATEGIES:
          console.log(`❌ ${data.type}`);
          PubSub.publish(pubsubEvents.socketKeys.CMED_STRATEGIES_FAILURE, data);
          if (
            data?.errors[0] ===
            pubsubEvents.errorMessage.REQUEST_ERROR_INVALID_PARAMETERS
          ) {
            PubSub.publish(pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST, {
              errors:
                pubsubEvents.errorMessage
                  .REQUEST_ERROR_ENTITLEMENT_OR_INVALID_PARAMETERS,
            });
          } else {
            PubSub.publish(
              pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST,
              data,
            );
          }
          break;
        case config.socket.actions.CMED_PERIODS_INSTRUMENT_ACTIONS:
          console.log(`❌ ${data.type}`);
          PubSub.publish(
            pubsubEvents.socketKeys.CMED_ALL_PERIODS_FAILURE,
            data,
          );
          if (
            data?.errors[0] ===
            pubsubEvents.errorMessage.REQUEST_ERROR_INVALID_PARAMETERS
          ) {
            PubSub.publish(pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST, {
              errors:
                pubsubEvents.errorMessage
                  .REQUEST_ERROR_ENTITLEMENT_OR_INVALID_PARAMETERS,
            });
          } else {
            PubSub.publish(
              pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST,
              data,
            );
          }
          break;
        case config.socket.actions.CMED_GET_CONTRACTS:
          endMetric(MetricConstants.CONTRACTS_FETCH_LATENCY);
          console.log(`❌ ${data.type}`);
          PubSub.publish(
            pubsubEvents.socketKeys.CMED_ALL_CONTRACTS_FAILURE,
            data,
          );
          if (
            data?.errors[0] ===
            pubsubEvents.errorMessage.REQUEST_ERROR_INVALID_PARAMETERS
          ) {
            PubSub.publish(pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST, {
              errors:
                pubsubEvents.errorMessage
                  .REQUEST_ERROR_ENTITLEMENT_OR_INVALID_PARAMETERS,
            });
          } else {
            if (data?.errors[0] !== "No contracts available")
              PubSub.publish(
                pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST,
                data,
              );
          }
          break;
        case config.socket.actions.CMED_ADD_CONTRACTS:
          console.log(`❌ ${data.type}`);
          PubSub.publish(
            pubsubEvents.socketKeys.CMED_ADD_CONTRACTS_FAILURE,
            data,
          );
          if (
            data?.errors[0] ===
            pubsubEvents.errorMessage.REQUEST_ERROR_INVALID_PARAMETERS
          ) {
            PubSub.publish(pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST, {
              errors:
                pubsubEvents.errorMessage
                  .REQUEST_ERROR_ENTITLEMENT_OR_INVALID_PARAMETERS,
            });
          } else if (
            data?.errors[0] === pubsubEvents.errorMessage.ERROR_ADD_CONTRACT
          ) {
            PubSub.publish(
              pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST_RETRY,
              {
                errors:
                  "There was an issue adding contract to group. Please try again.",
              },
            );
          } else {
            PubSub.publish(
              pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST,
              data,
            );
          }
          break;
        case config.socket.actions.CMED_ORDER_ENTRY:
        case config.socket.actions.CMED_ORDER_AGGRESSSION:
          console.log(`❌ ${data.type}`);
          endMetric(MetricConstants.ORDER_ENTRY_LATENCY);
          PubSub.publish(
            pubsubEvents.socketKeys.CMED_ORDER_ENTRY_REQUEST,
            data,
            { status: data.status },
          );
          if (
            data?.errors[0] ===
            pubsubEvents.errorMessage.REQUEST_ERROR_INVALID_PARAMETERS
          ) {
            PubSub.publish(pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST, {
              errors:
                pubsubEvents.errorMessage
                  .REQUEST_ERROR_RESPONSE_INVALID_PARAMETERS,
            });
          } else {
            PubSub.publish(
              pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST,
              data,
            );
          }
          break;
        default:
          console.log(`🔴 No matching error action found for ${data.type}`);
          // PubSub.publish(pubsubEvents.errorKeys.MARKET_SERVICE_ERROR_TOAST, data)
          break;
      }
    }
  } else {
    switch (data.type) {
      case "TradingGridGroups":
        console.log(`✅ ${data.type}`);
        PubSub.publish(
          pubsubEvents.stompSubscriptionKeys.CMED_TRADING_GRID_GROUPS_UPDATE,
          data,
        );
        break;
      case "TradingGridGroupItemMarketData":
        console.log(`✅ ${data.type}`);
        PubSub.publishSync(
          pubsubEvents.stompSubscriptionKeys
            .CMED_TRADING_GRID_GROUP_ITEM_UPDATE,
          data,
        );
        break;
      case "cmedOrderEntryCriteria":
        console.log(`✅ ${data.type}`);
        PubSub.publish(pubsubEvents.socketKeys.CMED_ORDER_ENTRY_RESPONSE, data);
        break;
      case "cmedPriceTicks":
        console.log(`✅ ${data.type}`);
        PubSub.publish(pubsubEvents.socketKeys.CMED_PRICE_TICKS_RESPONSE, data);
        break;
      case "cmedNewOrder":
        console.log(`✅ ${data.type}`);
        endMetric(MetricConstants.ORDER_ENTRY_LATENCY);
        if (data.action === config.socket.actions.CMED_ORDER_ENTRY) {
          PubSub.publish(pubsubEvents.socketKeys.CMED_NEW_ORDER_SUCCESS, data, {
            status: data.status,
          });
        } else {
          PubSub.publish(
            pubsubEvents.socketKeys.CMED_AGGRESSION_ORDER_SUCCESS,
            data,
            { status: data.status },
          );
        }
        break;
      case "instruments":
        console.log(`✅ ${data.type}`);
        PubSub.publish(pubsubEvents.socketKeys.CMED_ALL_PRODUCTS_SUCCESS, data);
        break;
      case "strategies":
        console.log(`✅ ${data.type}`);
        PubSub.publish(pubsubEvents.socketKeys.CMED_STRATEGIES_SUCCESS, data);
        break;
      case "periods":
        console.log(`✅ ${data.type}`);
        PubSub.publish(pubsubEvents.socketKeys.CMED_ALL_PERIODS_SUCCESS, data);
        break;
      case "contracts":
        console.log(`✅ ${data.type}`);
        endMetric(MetricConstants.CONTRACTS_FETCH_LATENCY);
        PubSub.publish(
          pubsubEvents.socketKeys.CMED_ALL_CONTRACTS_SUCCESS,
          data,
        );
        break;
      case "cmedContractAdded":
        console.log(`✅ ${data.type}`);
        PubSub.publish(
          pubsubEvents.socketKeys.CMED_ADD_CONTRACTS_SUCCESS,
          data,
        );
        break;
      case "cmedContractRemoved":
        console.log(`✅ ${data.typed}`);
        PubSub.publish(
          pubsubEvents.socketKeys.CMED_CONTRACT_REMOVED_SUCCESS,
          data,
        );
        break;
      default:
        console.log(`🔴 No matching action found for ${data.type}`);
        break;
    }
  }
  console.groupEnd();
}

// export { cmed_block_feed_messageReceived as default }
